import { render } from "./TournamentStartListDMM.vue?vue&type=template&id=75f28df3&scoped=true"
import script from "./TournamentStartListDMM.vue?vue&type=script&lang=js"
export * from "./TournamentStartListDMM.vue?vue&type=script&lang=js"

import "./TournamentStartListDMM.vue?vue&type=style&index=0&id=75f28df3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f28df3"]])

export default __exports__